import {
  ClientAuthError,
  InteractionRequiredAuthError,
  UserAgentApplication,
} from "msal";
import { faMicrosoft } from "@fortawesome/free-brands-svg-icons";
import identity from "../model/identity";
import config from "../config/config";

class AuthService {
  constructor(configuration) {
    this.signInOptions = {
      scopes: configuration.msal.scopes,
    };

    this.msalConfig = {
      auth: {
        authority: configuration.msal.authority,
        clientId: configuration.msal.clientId,
        redirectUri: window.location.origin, //window.location.href
        navigateToLoginRequestUrl: true,
        validateAuthority: true,
          
      },
      cache: {
        cacheLocation: "localStorage", //"sessionStorage",
        storeAuthStateInCookie: true,
      },
        framework: {
            unprotectedResources: ['https://www.microsoft.com/en-us/'],
        },
      
    };
    
    if (!this.msalClient || this.msalClient === undefined) {
      this.msalClient = new UserAgentApplication(this.msalConfig);
    } 
  }

  get serviceName() {
    return "Microsoft";
  }

  get icon() {
    return faMicrosoft;
  }

  async signIn() {
    const response = await this.msalClient.loginPopup(this.signInOptions);
    return new identity(response);
  }

  async getAccount() {
    let response = await this.msalClient.getAccount();
    let account = { account: response };
    account = new identity(account);
    return new identity(account);
  }

  signOut() {
    this.msalClient.logout();
    this.msalClient = null;
  }

  async acquireToken(scopes = ["user.read"]) {
    if (!this.msalClient) {
      return null;
    }

    // Set scopes for token request
    const accessTokenRequest = {
      scopes,
    };

    let tokenResp;
    try {
      tokenResp = await this.msalClient.acquireTokenSilent(accessTokenRequest);
    } catch (err) {
      tokenResp = await this.msalClient.acquireTokenPopup(accessTokenRequest);
    }

    // Just in case check, probably never triggers
    if (!tokenResp.accessToken) {
      throw new Error("### accessToken not found in response, that's bad"); 
    }

    return tokenResp.accessToken;
  }

  async getIdentity() {
    const account = this.msalClient.getAccount();
    if (account) {
      try {
        const response = await this.msalClient.acquireTokenSilent(
          this.signInOptions
        );
        return new identity(response);
      } catch (error) {
        if (error instanceof InteractionRequiredAuthError) {
          console.log(error);
        }
        if (error instanceof ClientAuthError) {
          if (error.errorCode === "block_token_requests") {
            console.log(error);
          }
          console.warn("ClientAuthError: error code = ", error.errorCode);
        }
        throw error;
      }
    }
    console.log("error");
  }

  clearLocal() {
    if (this.msalClient) {
      this.msalClient.cacheStorage.clear();
    }
  }
}

const authService = new AuthService(config);

export default authService;
